(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ActividadEvaDoceDialogController', ActividadEvaDoceDialogController);

    ActividadEvaDoceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ActividadesEvaluacion', 'Instituciones','Periodos','TipoActividadesEvaluacion','AniosEscolares','NivelesEducativosService','ModelosEducativosService'];

    function ActividadEvaDoceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ActividadesEvaluacion, Instituciones,Periodos,TipoActividadesEvaluacion,AniosEscolares,NivelesEducativosService,ModelosEducativosService) {
        var vm = this;

        vm.actividad = entity;
//        console.log(vm.actividad);
        $scope.format = 'yyyy-MM-dd';
        vm.clear = clear;
        vm.save = save;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.selectedTipo;
        vm.institucionSelected;
        vm.anioSelected;
        vm.indicePeriodo;
        vm.intercurso;
        vm.limpiar = limpiar;
        vm.compararTipoActMEFI = compararTipoActMEFI;
        vm.tipoActAutoEva = "Autoevaluación de Profesores";
        vm.periodos;
        cargarDropDowns();
//        vm.counter = 0;
//        console.log(vm.actividad);
        $scope.$watchGroup(["vm.actividad.anioEscolar","vm.actividad.institucion","vm.actividad.intercurso"],function(newValue,oldValue){
        	if (newValue === oldValue) {
      	      return;
      	    }
      	 
//	      	console.log("El valor ha cambiado ");
//	      	console.log(newValue);
//	      	vm.counter++;	
//	      	console.log(vm.counter);
//	      	console.log(newValue[0]);
//	      	console.log(newValue[1]);
//	      	console.log(newValue[2]);
//        	console.log(vm.actividad);
        	
        	vm.periodos = null;
        	if(vm.actividad.anioEscolar != null && vm.actividad.institucion != null){
        		vm.periodos = Periodos.query({
            		anio: vm.actividad.anioEscolar.id,
            		dep: vm.actividad.institucion.id,
            		ic: vm.actividad.intercurso
                });
        	}
	      	
        });
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function limpiar() {
        	vm.actividad.tipoActividad = null;
        	vm.actividad.institucion = null;
        	vm.actividad.anioEscolar = null;
        	vm.actividad.intercurso = false;
        	vm.actividad.inicio = null;
        	vm.actividad.fin = null;
        	vm.actividad.modeloEducativo = null;
        }
        
        function compararTipoActMEFI(texto){
        	texto = normalizar(texto);
        	
        	if (texto.indexOf(normalize('Autoevaluación de Profesores'))>=0) {
        	      return true;
        	    } else {
        	      return false;
        	    }
        	
        }
        
        function normalizar(texto){
        	texto = texto.replace(/[áàäâ]/g, "a");
        	texto = texto.replace(/[éèëê]/g, "e");
        	texto = texto.replace(/[íìïî]/g, "i");
        	texto = texto.replace(/[óòôö]/g, "o");
        	texto = texto.replace(/[úùüü]/g, "u");
        	texto = texto.toUpperCase();
        	return texto;
        }

        function save () {
            vm.isSaving = true;
            if (vm.actividad.id !== null) {
            	ActividadesEvaluacion.update(vm.actividad, onSaveSuccess, onSaveError);
            } else {
            	ActividadesEvaluacion.save(vm.actividad, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sideApp:actividadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function cargarDropDowns(){
        	vm.dependencias=Instituciones.query();
        	vm.tiposActividades=TipoActividadesEvaluacion.query();
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.nivelesEducativos=NivelesEducativosService.getAll();
        	
        	vm.modelosEducativos=ModelosEducativosService.getAll();
        }
        

    }
})();
